import { render, staticRenderFns } from "./ActorRoleUpdateScreen.vue?vue&type=template&id=05841bd0&"
import script from "./ActorRoleUpdateScreen.vue?vue&type=script&lang=js&"
export * from "./ActorRoleUpdateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports